import { styled } from 'styled-components';
import THEME from '../theme.js';
export const PreviewWrapper = styled.div `
  padding: 15px 10px;
  margin: 10px;
  border-radius: 3px;
  cursor: pointer;
  background: ${(props) => (props.selected ? THEME.COLOR_ACCENT : '#FFF')};
  color: ${(props) => (props.selected ? '#FFF' : '#000')};

  & h1 {
    font-size: 1.5em;
    font-weight: normal;
  }

  & .subject {
    font-weight: bold;
  }

  & .address {
    font-size: 0.8em;
  }
`;
//# sourceMappingURL=PreviewWrapper.js.map